import { RouterProvider } from "react-router-dom";
import { router } from "./views/router";
import { Theme } from "@radix-ui/themes";

import { Provider } from "react-redux";
import { store } from "./store";
import { Toaster } from "react-hot-toast";
import { initTranslation } from "./i18n";

initTranslation();

function App() {
  return (
    <Provider store={store}>
      <Theme grayColor="mauve">
        <RouterProvider router={router} />
      </Theme>
      <Toaster position="top-center" reverseOrder={false} />
    </Provider>
  );
}

export default App;
